import React from 'react';
import StringFieldProto from './url-proto.jsx';


export default function renderStringInView(id, props) {
    return <StringFieldProto renderMode="edit" id={id} {...props} />;
}